/**************************************************************************
 *  ADOBE CONFIDENTIAL
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of Adobe and its suppliers, if any. The intellectual
 *  and technical concepts contained herein are proprietary to Adobe
 *  and its suppliers and are protected by all applicable intellectual
 *  property laws, including trade secret and copyright laws.
 *  Dissemination of this information or reproduction of this material
 *  is strictly forbidden unless prior written permission is obtained
 *  from Adobe.
 **************************************************************************/
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export default class PolyfillUtils {
	static promisesAllSettled = function (promises) {
		const mappedPromises = promises.map((promise) =>
			promise
				.then((value) => ({
					status: 'fulfilled',
					value,
				}))
				.catch((reason) => ({
					status: 'rejected',
					reason,
				})),
		);
		return Promise.all(mappedPromises);
	};

	static delayedPromise = function (fn, delay) {
		return new Promise((resolve, reject) => {
			if (typeof fn !== 'function') {
				reject('Invalid function passed to delayedPromise');
				return;
			}
			setTimeout(() => {
				try {
					fn();
					resolve(true);
				} catch (error: any) {
					reject(error.message);
				}
			}, delay);
		});
	};
}
